import { Controller } from "@hotwired/stimulus"

// Carrousel des offres flash. Son seul rôle est l'affordance : sur mobile
// rien n'indique qu'on peut faire défiler horizontalement (la barre de
// défilement native est masquée), donc on affiche un repère "faites glisser"
// + une barre de progression — et on les cache dès que tout tient à l'écran
// ou que l'utilisateur a compris et commencé à glisser.
export default class extends Controller {
  static targets = ["track", "hint", "progress", "progressBar"]

  connect() {
    this.onScroll = this.onScroll.bind(this)
    this.syncAffordance = this.syncAffordance.bind(this)

    this.trackTarget.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.syncAffordance)

    if (typeof ResizeObserver !== "undefined") {
      this.observer = new ResizeObserver(this.syncAffordance)
      this.observer.observe(this.trackTarget)
    }

    this.syncAffordance()
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.syncAffordance)
    this.observer?.disconnect()
  }

  get scrollableWidth() {
    return this.trackTarget.scrollWidth - this.trackTarget.clientWidth
  }

  // 4px de marge : des arrondis de sous-pixel suffisent à faire croire à un
  // débordement sur un conteneur qui tient pourtant parfaitement.
  get isScrollable() {
    return this.scrollableWidth > 4
  }

  syncAffordance() {
    const scrollable = this.isScrollable
    if (this.hasProgressTarget) this.progressTarget.hidden = !scrollable
    if (this.hasHintTarget) this.hintTarget.hidden = !scrollable || this.dismissedHint
    this.renderProgress()
  }

  onScroll() {
    if (!this.dismissedHint && this.trackTarget.scrollLeft > 12) {
      this.dismissedHint = true
      if (this.hasHintTarget) this.hintTarget.hidden = true
    }
    this.renderProgress()
  }

  // Vrai "pouce" de défilement : sa largeur dit quelle part des offres est
  // visible, sa position où l'on en est — plus informatif qu'une barre qui
  // se remplit.
  renderProgress() {
    if (!this.hasProgressBarTarget || !this.isScrollable) return
    const visibleRatio = this.trackTarget.clientWidth / this.trackTarget.scrollWidth
    const thumbWidth = Math.max(18, Math.min(100, visibleRatio * 100))
    const ratio = this.trackTarget.scrollLeft / this.scrollableWidth
    this.progressBarTarget.style.width = `${thumbWidth}%`
    this.progressBarTarget.style.left = `${ratio * (100 - thumbWidth)}%`
  }
}
